'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'navbarReveal', () => ({
		lastPos : window.scrollY,
		scrollUp: false,

		scroll() {
			if ( ( window.scrollY > this.$refs.siteHeader.offsetHeight ) && ( this.lastPos > window.scrollY ) ) {
				this.scrollUp = true;
			} else {
				this.scrollUp = false;
			}

			this.lastPos = window.scrollY;
		},

	}) );
});
